import "./NewPasswordModal.css";
import { Form, Modal } from "react-bootstrap";
import React, { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";

// Form Validate imports Start
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
// Form Validate imports End

// Form Validate schema Start
const schema = yup.object().shape({
  password: yup.string().min(6).max(15).required("Password is Required!"),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password"), null], "Passwords doesn't match!"),
});

// Form Validate schema End

const NewPasswordModal = ({
  PassModal,
  proceedToOTPModal,
  closeModals,
  setPass,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const [Loading, setLoading] = useState(false);
  const [Password, setPassword] = useState("");
  const [ConfirmPassword, setConfirmPassword] = useState("");
  const [passwordShown, setPasswordShown] = useState(false);
  const [confirmPasswordShown, setConfirmPasswordShown] = useState(false);
  const [FormDisabled, setFormDisabled] = useState(false);

  const [ShowNewPasswordModal, setShowNewPasswordModal] = useState(false);
  const handleShowNewPasswordModal = () => {
    setShowNewPasswordModal(true);
  };
  const handleCloseNewPasswordModal = () => {
    setShowNewPasswordModal(false);
  };

  useEffect(() => setPass(watch("password")), [watch("password")]);

  // Password toggle handler
  const togglePassword = () => {
    // When the handler is invoked
    // inverse the boolean state of passwordShown
    setPasswordShown(!passwordShown);
  };

  // Password toggle handler
  const toggleConfirmPassword = () => {
    // When the handler is invoked
    // inverse the boolean state of confirmPasswordShown
    setConfirmPasswordShown(!confirmPasswordShown);
  };

  const submitForm = (e) => {
    console.log(e);
    return;
    setFormDisabled(true);
    setLoading(true);
    setFormDisabled(false);
  };
  return (
    <>
      {/* <Link
        to="#"
        onClick={handleShowNewPasswordModal}
        style={{ fontSize: "20px", color: "#000000", fontWeight: 500 }}
      >
        New Password Modal
      </Link> */}
      <Fragment>
        <Modal
          show={PassModal}
          // onHide={handleCloseNewPasswordModal}
          keyboard={false}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <p onClick={closeModals}>
            <svg
              style={{
                position: "absolute",
                top: "-4px",
                right: "-6px",
                width: "24px",
                height: "24px",
                cursor: "pointer",
              }}
              width="44"
              height="44"
              viewBox="0 0 44 44"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_d_216_88)">
                <path
                  d="M22 0C12.046 0 4 8.046 4 18C4 27.954 12.046 36 22 36C31.954 36 40 27.954 40 18C40 8.046 31.954 0 22 0ZM31 24.462L28.462 27L22 20.538L15.538 27L13 24.462L19.462 18L13 11.538L15.538 9L22 15.462L28.462 9L31 11.538L24.538 18L31 24.462Z"
                  fill="black"
                />
              </g>
              <defs>
                <filter
                  id="filter0_d_216_88"
                  x="0"
                  y="0"
                  width="44"
                  height="44"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_216_88"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_216_88"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </p>

          <Modal.Body
            style={{
              height: "500px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <svg
                style={{ margin: "0px 0px 14px 0px" }}
                width="56"
                height="56"
                viewBox="0 0 56 56"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="28"
                  cy="28"
                  r="28"
                  fill="#4E36A8"
                  fillOpacity="0.2"
                />
                <g clipPath="url(#clip0_219_97)">
                  <path
                    d="M26.2802 36.7971C27.4906 35.9178 28.3607 34.648 28.7439 33.2018C29.127 31.7557 28.9998 30.2216 28.3837 28.8583L30.5944 27.2567L32.1182 29.3601L34.2216 27.8362L32.6977 25.7328L34.8011 24.209L37.087 27.3641L39.1904 25.8402L36.9045 22.6851L37.9562 21.9231L36.4324 19.8197L26.8598 26.7549C25.7564 25.7447 24.3383 25.1459 22.8448 25.0594C21.3512 24.9729 19.8735 25.404 18.6608 26.2801C15.7613 28.3808 15.1114 32.4488 17.2121 35.3483C19.3127 38.2479 23.3807 38.8978 26.2802 36.7971ZM20.1847 28.3835C21.9242 27.1233 24.3654 27.5133 25.6256 29.2528C26.8859 30.9923 26.4959 33.4335 24.7564 34.6937C23.0169 35.954 20.5757 35.564 19.3154 33.8244C18.0552 32.0849 18.4452 29.6438 20.1847 28.3835Z"
                    fill="#4E36A8"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_219_97">
                    <rect
                      width="31.1688"
                      height="31.1688"
                      fill="white"
                      transform="translate(5.96533 24.252) rotate(-35.9229)"
                    />
                  </clipPath>
                </defs>
              </svg>

              <h3 style={{ fontSize: "26px", fontWeight: 600 }}>
                Set New Password
              </h3>
              <p
                style={{
                  fontSize: "14px",
                  color: "#7c7777",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  // margin: "14px 0px 0px 0px",
                }}
              >
                Try to make your password strong by using
                <span>alphabets, numbers and special characters.</span>
              </p>
            </div>
            <form onSubmit={handleSubmit(submitForm)}>
              <div className="form-group showHidePassword">
                <label className="registerLabel mb-1 float-start">
                  New Password
                </label>
                <span
                  onClick={togglePassword}
                  className={`profilePasswordOpenCloseEyeIcon ${
                    passwordShown ? "bi bi-eye-fill" : "bi bi-eye-slash-fill"
                  } `}
                ></span>
                <input
                  type={passwordShown ? "text" : "password"}
                  className={`form-control input-style`}
                  // placeholder="Password"
                  name="password"
                  onChange={(e) => setPassword(e.target.value)}
                  {...register("password")}
                  disabled={FormDisabled}
                />
                <p className="errorMessage">{errors?.password?.message}</p>
              </div>

              <div className="form-group mt-3 showHidePassword">
                <label className="registerLabel mb-1 float-start">
                  Confirm New Password
                </label>
                <span
                  onClick={toggleConfirmPassword}
                  className={`profileConfirmPasswordOpenCloseEyeIcon ${
                    confirmPasswordShown
                      ? "bi bi-eye-fill"
                      : "bi bi-eye-slash-fill"
                  } `}
                ></span>
                <input
                  type={confirmPasswordShown ? "text" : "password"}
                  className={`form-control input-style`}
                  // placeholder="Confirm Password"
                  name="confirmPassword"
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  {...register("confirmPassword")}
                  disabled={FormDisabled}
                />
                <p className="errorMessage">
                  {errors?.confirmPassword?.message}
                </p>
              </div>

              <div class="text-center">
                <button
                  style={{ height: "45px" }}
                  type="submit"
                  class="btn btn-primary btn-block"
                  onClick={handleSubmit(proceedToOTPModal)}
                  disabled={Loading}
                >
                  {Loading ? (
                    <div class="spinner-border" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  ) : (
                    "Next"
                  )}
                </button>
              </div>
            </form>
          </Modal.Body>
        </Modal>
      </Fragment>
    </>
  );
};

export default NewPasswordModal;
